import { render } from "./UpsertScopeComponent.vue?vue&type=template&id=3d9ba378"
import script from "./UpsertScopeComponent.vue?vue&type=script&lang=js"
export * from "./UpsertScopeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__